module.exports = {"CONTACT_TITLE":"Contact"}


//////////////////
// WEBPACK FOOTER
// ./src/locales/contact/contact.en.json
// module id = Kht9
// module chunks = 0